import { useResizeX } from 'Hooks/useResize';
import useWindowDimensions from 'Hooks/useWindowSize';
import React, { useRef } from 'react';
import {
  ResizerWrapper, Resizer
} from 'Screens/Contextualization/Host/components/HostDetail/styled';
import { useSelector } from 'react-redux';
import selectModal from 'store/modals/selectors';
import { MODAL_AGENT_EXECUTOR_DETAIL } from 'store/modals/modals';
import Wrapper from '../../../AgentDetail/styled';
import Content from './Content';

const AgentExecutorDetail = () => {
  const show = useSelector((state) => selectModal(state, MODAL_AGENT_EXECUTOR_DETAIL));
  const wrapperRef = useRef(null);
  const resizerRef = useRef(null);
  const { width } = useWindowDimensions();
  const minWidth = width < 3000 ? width * 0.55 : width * 0.35;
  const maxWidth = width < 3000 ? width * 0.75 : width * 0.55;
  const wrapperWidth = useResizeX(wrapperRef, resizerRef, minWidth, minWidth, maxWidth);

  if (!show) return null;
  return (
    <Wrapper ref={ wrapperRef } wrapperWidth={ wrapperWidth }>
        <ResizerWrapper ref={ resizerRef } children={ <Resizer /> } />
        <Content />
    </Wrapper>
  );
};

export default AgentExecutorDetail;
